/* global HTMLElement, HTMLVideoElement */

import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'
import cookie from 'amkit3-modules/utils/cookie'
import HuyaPlayerCore from './core'

const HTML_PLAYER_BLOCK = 'amkit3-v-player-html-block'
class HuyaPlayer {
  constructor(container, options, ready) {
    this.isBrowserSupported(err => {
      if (!err) {
        this.core = new HuyaPlayerCore(container, options, ready)
      } else {
        ready(err)
      }
    })
  }
  isBrowserSupported(cb) {
    try {
      let _hasHTMLElement = document.createElement('div') instanceof HTMLElement
      let _hasHTMLVideoElement = document.createElement('video') instanceof HTMLVideoElement

      if (global.navigator.userAgent.indexOf('49.0.2623.110') >= 0) {
        cb(new Error('not support this browser version'))
        // } else if (cookie.get(HTML_PLAYER_BLOCK)) {
        //   cb(new Error('block by cookie'))
      } else if (!_hasHTMLElement) {
        cb(new Error('no HTMLElement constructor'))
      } else if (!_hasHTMLVideoElement) {
        cb(new Error('no HTMLVideoElement constructor'))
      } else {
        cb()
      }
    } catch (e) {
      cb(e)
    }
  }
  // External Interfaces
  getVid() {
    if (this.core) return this.core.getVid()
    return ''
  }
  getChannelId() {
    if (this.core) return this.core.getChannelId()
    return ''
  }
  getLaiyuanv3() {
    if (this.core) return this.core.getLaiyuanv3()
    return ''
  }
  getVname() {
    if (this.core) return this.core.getVname()
    return ''
  }
  getCurrentTime() {
    if (this.core) return this.core.getCurrentTime()
    else return 0
  }
  getVolume() {
    if (this.core) return this.core.getVolume()
    else return 0
  }
  getPlayerState() {
    if (this.core) return this.core.getPlayerState()
    else return 'ready'
  }
  getDuration() {
    if (this.core) return this.core.getDuration()
    else return 0
  }
  seek(value) {
    if (this.core) this.core.seek(value)
  }
}

export default HuyaPlayer
